/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Nav_BackInputs */

const de_commons_nav_back = /** @type {(inputs: Commons_Nav_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

/** @type {(inputs: Commons_Nav_BackInputs) => LocalizedString} */
const en_commons_nav_back = de_commons_nav_back;

/**

* @param {Commons_Nav_BackInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_nav_back = /** @type {((inputs?: Commons_Nav_BackInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Nav_BackInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_nav_back(inputs)
	return en_commons_nav_back(inputs)
});